import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './LoginForm.css';

const LoginForm = ({ onClose, onSwitchToSignup }) => {
  const { login, loginWithSSO } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const result = await login(formData.email, formData.password);
      if (!result.success) {
        setError(result.error || 'Login failed');
      }
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSSOLogin = async (provider) => {
    setIsLoading(true);
    setError('');

    try {
      const result = await loginWithSSO(provider);
      if (!result.success) {
        setError(result.error || `Failed to login with ${provider}`);
      }
    } catch (err) {
      setError(`Failed to login with ${provider}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-overlay">
      <div className="login-container">
        <div className="login-header">
          <h2>Welcome Back</h2>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <form onSubmit={handleEmailLogin} className="login-form">
          <div className="input-group">
            <input
              type="email"
              name="email"
              placeholder="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="login-input"
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              name="password"
              placeholder="password"
              value={formData.password}
              onChange={handleInputChange}
              required
              className="login-input"
            />
          </div>

          <div className="login-options">
            <button type="button" className="forgot-password">Forgot your password?</button>
          </div>

          <div className="remember-me">
            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span className="checkmark"></span>
              Remember me on this device
            </label>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className="signin-btn"
            disabled={isLoading}
          >
            {isLoading ? 'SIGNING IN...' : 'SIGN IN'}
          </button>
        </form>

        <div className="divider">
          <span>OR</span>
        </div>

        <div className="sso-buttons">
          <button 
            className="sso-btn kakao"
            onClick={() => handleSSOLogin('kakao')}
            disabled={isLoading}
          >
            <div className="sso-icon">
              <i className="fas fa-comment"></i>
            </div>
            <span>TALK</span>
          </button>

          <button 
            className="sso-btn naver"
            onClick={() => handleSSOLogin('naver')}
            disabled={isLoading}
          >
            <div className="sso-icon">N</div>
          </button>

          <button 
            className="sso-btn google"
            onClick={() => handleSSOLogin('google')}
            disabled={isLoading}
          >
            <div className="sso-icon">G</div>
          </button>

          <button 
            className="sso-btn apple"
            onClick={() => handleSSOLogin('apple')}
            disabled={isLoading}
          >
            <div className="sso-icon">
              <i className="fab fa-apple"></i>
            </div>
          </button>
        </div>

        <div className="signup-link">
          <span>Don't have an account? </span>
          <button onClick={onSwitchToSignup} className="signup-link-btn">
            Sign Up Here
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
